/*
 * @Author: gongzhizhen
 * @Date: 2019-05-31 15:25:41
 * @LastEditTime: 2019-07-09 15:28:33
 * @LastEditors: gongzhizhen
 */

// 手机号码校验
export const phoneValidator = (num, mobilePhone) => {
  if (!mobilePhone) {
    return false;
  }
  /**
   * 手机号码:
   * 13[0-9], 14[5,7], 15[0, 1, 2, 3, 5, 6, 7, 8, 9], 17[0, 1, 6, 7, 8], 18[0-9]
   * 移动号段: 134,135,136,137,138,139,147,150,151,152,157,158,159,170,178,182,183,184,187,188,198, 197,195
   * 联通号段: 130,131,132,145,146,155,156,170,171,175,176,185,186,166, 196
   * 电信号段: 133,149,153,170,173,177,180,181,189,199, 190,191,193,
   * 中国广电: 192
   */
  // return /^(1[34578][0-9][- ]?\d{4}[- ]?\d{4})|(\d{3,4}[- ]?\d{3,4}[- ]?\d{4})$/
  return /^1(3[0-9]|4[567]|5[0-35-9]|66|7[01235678]|8[0-9]|9[0-35-9])\d{8}$/.test(num);
};

// 校验虚拟运营商手机号
export const checkPhone = value => {
  return !/^17(0|1)\d{8}$/.test(value);
};

export default {
  phoneValidator,
  checkPhone,
};
